import React from 'react';
import { Modal } from '../ui/Modal';
import { Button } from '../ui/Button';
interface ConfirmDialogProps {
  open: boolean;
  title: string;
  description: string;
  confirmLabel?: string;
  loading?: boolean;
  /** Contenido adicional (por ejemplo, elegir a dónde mover los leads). */
  children?: React.ReactNode;
  onCancel: () => void;
  onConfirm: () => void;
}
export function ConfirmDialog({
  open,
  title,
  description,
  confirmLabel = 'Eliminar',
  loading = false,
  children,
  onCancel,
  onConfirm
}: ConfirmDialogProps) {
  return <Modal open={open} onClose={onCancel} title={title} footer={<div className="flex justify-end gap-2" data-id="element-93" data-mp="2hli4wf522nkh">
          <Button variant="ghost" onClick={onCancel} disabled={loading} data-id="element-94" data-mp="2him6yqt7jyw1">
            Cancelar
          </Button>
          <Button variant="destructive" onClick={onConfirm} loading={loading} data-id="element-95" data-mp="3a9e01fez87f5">
            {confirmLabel}
          </Button>
        </div>} data-id="element-92" data-mp="2vbbrsrx02xrk">
      <p className="text-sm text-muted-foreground" data-id="element-96" data-mp="3f15sjvhp0n7x">{description}</p>
      {children && <div className="mt-4" data-id="element-97" data-mp="2bg7e5ow922vv">{children}</div>}
    </Modal>;
}